type AttachmentLike =
	| {
			Url?: string;
			FileName?: string;
	  }
	| null
	| undefined;

const IMAGE_EXTENSION_PATTERN =
	/\.(avif|bmp|gif|heic|heif|jpe?g|png|svg|webp)$/i;

const stripUrlSuffix = (value: string): string =>
	value.split("#")[0]?.split("?")[0] ?? value;

export const isImageAttachment = (attachment: AttachmentLike): boolean => {
	if (!attachment) return false;

	const fileName = attachment.FileName?.trim();
	if (fileName && IMAGE_EXTENSION_PATTERN.test(fileName)) return true;

	const url = attachment.Url?.trim();
	if (!url) return false;

	return IMAGE_EXTENSION_PATTERN.test(stripUrlSuffix(url));
};
